import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

import css from "./index.module.css";
import logo from "../../assets/morph3dbot_logo_white.svg";
import logoSimple from "../../assets/morph3dbot_logo_simple.png";
import LogoutIcon from "@mui/icons-material/Logout";
import { useEffect, useState } from "react";
import { getData, getDataById } from "../../utils/fetch";

/**
 * custom header component
 * @param {Boolean} isTeacher determines if the navbar shows links for teacher or student sites 
 * @returns a navigation bar depending on the user role
 */
const Header = ({ isTeacher, nav }) => {
	const { studentId, teacherId } = useParams();
	const [classId, setClassId] = useState(null);
	const [challengeToMission, setChallengeToMission] = useState([]);
	const [studentToMission, setStudentToMission] = useState([]);
	const [studentToChallenge, setStudentToChallenge] = useState([]);
	const [available, setAvailable] = useState(0);
	const [classToChallenges, setClassToChallenges] = useState([]);

	useEffect(() => {
		if(!isTeacher) {
			getDataById("/api/students/byId", {id: studentId}).then(data => {
				setClassId(data.class_id);
				getDataById("/api/classToChallenges/byId", { classId: data.class_id }).then(data => setClassToChallenges(data));
			})
			getData("/api/challengeToMissions").then(data => setChallengeToMission(data));
			getData("/api/studentToMission").then(data => setStudentToMission(data.filter(f => f.student_id === studentId)));
			getData("/api/studentToChallenge").then(data => setStudentToChallenge(data.filter(f => f.student_id === studentId)));
		}
		
		//

	},[studentId]);

	/**
	 * calculates available challenges for the given student to display as small info number in the header-tab for challenges
	 */
	useEffect(() => {
		if (
			!challengeToMission.length ||
			!studentToChallenge.length ||
			!studentToMission.length ||
			!classToChallenges?.length
		) return;

		const startedChallenges = new Set(
			studentToChallenge.map(e => e.challenge_id)
		);

		const enabledChallenges = new Set(
			classToChallenges.map(e => e.challenge_id)
		);

		const completedMissions = new Set(
			studentToMission.map(e => e.mission_id)
		);

		const challengeMissions = new Map();
		for (const { challenge_id, mission_id } of challengeToMission) {
			if (!challengeMissions.has(challenge_id)) {
				challengeMissions.set(challenge_id, []);
			}
			challengeMissions.get(challenge_id).push(mission_id);
		}

		let available = 0;
		for (const [challengeId, missions] of challengeMissions) {
			if (startedChallenges.has(challengeId)) continue;
			if (!enabledChallenges.has(challengeId)) continue;

			const allDone = missions.every(missionId =>
				completedMissions.has(missionId)
			);

			if (allDone) available++;
		}

		setAvailable(available);
	}, [
		challengeToMission,
		studentToChallenge,
		studentToMission,
		classToChallenges
	]);

  return (
    <div className={css.container}>
      <div className={css.headercontainer}>
        <img src={window.innerWidth > 1300 ? logo : logoSimple} alt="Logo" className={css.logo} />
        {isTeacher ? (
          <div className={css.navLinks}>
            <Link to={`/teacher/${teacherId}`}>
              <span className={nav === "Klassen" ? css.selectedLink : css.unselectedLink}>
                Klassen
              </span>
            </Link>
            <Link to={`/teacher/${teacherId}/content`}>
							<span className={nav === "Lerninhalte" ? css.selectedLink : css.unselectedLink}>
								Lerninhalte
							</span>
						</Link>
            <Link to={`/teacher/${teacherId}/progress/${classId}`}>
							<span className={nav === "Lernfortschritt" ? css.selectedLink : css.unselectedLink}>
								Lernfortschritt
							</span>
						</Link>
          </div>
        ) : (
          <div className={css.navLinks}>
						<Link to={`/student/${studentId}/missions`}>
							<span className={nav === "Mission" ? css.selectedLink : css.unselectedLink}>
								Missionen
							</span>
						</Link>
						<Link to={`/student/${studentId}/challenges`}>
						{available !== 0 && <div className={css.amount}>{available}</div>}
							<span className={nav === "Challenge" ? css.selectedLink : css.unselectedLink}>
								Challenges
							</span>
							
						</Link>
						<Link to={`/student/${studentId}/scoreboard`}>
							<span className={nav === "Scoreboard" ? css.selectedLink : css.unselectedLink}>
								Scoreboard
							</span>
						</Link>
						<Link to={`/student/${studentId}/cheatsheet`}>
							<span className={nav === "Cheatsheet" ? css.selectedLink : css.unselectedLink}>
								Cheat sheet
							</span>
						</Link>
						<Link to={`/student/${studentId}/settings`}>
							<span className={nav === "Einstellungen" ? css.selectedLink : css.unselectedLink}>
								Einstellungen
							</span>
						</Link>
          </div>
        )}

        <Link to="/login" className={css.loginLink}>
          <LogoutIcon />
        </Link>
      </div>
    </div>
  );
};
export default Header;
